export enum ErrorSeverityLevel {
    Low = 1, // Error in which user or workflow in not impacted.
    Medium = 2, // Error which can impact a feature or workflow partially but user can proceed to complete it with workarounds. 
    High = 3, // Any error which can bring feature(s) down. 
    Critical = 4 // Any error which can bring FxP Platform down. 
} 